import React, { useState } from "react";

import PropTypes from "prop-types";

import AccordionUpIcon from "../SVGs/AccordionUpIcon";
import { WPTypography } from "../WPTypography";

import { combineClassNames } from "../../utils/appUtils";

import "./WPAccordion.scss";

const WPAccordion = ({ title, children, defaultOpen, type, sideInfo }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleToggle = (event) => {
    const tagName = event?.target?.tagName?.toLowerCase();
    if (tagName === "input" || tagName === "label") {
      return;
    }
    setIsOpen((prev) => !prev);
  };

  return (
    <div className={`wp-accordion ${type ? `wp-accordion-${type}` : ""}`}>
      <div className="wp-accordion-header-wrapper" onClick={handleToggle}>
        {typeof title === "string" ? (
          <WPTypography
            fontFamily="Diodrum"
            text={title}
            className="wp-accordion-header"
            asElement="div"
          />
        ) : (
          <div className="wp-accordion-header">{title}</div>
        )}
        <WPTypography
          text={sideInfo}
          className="wp-accordion-sideInfo"
          asElement="div"
          align="right"
        />
        <div
          className={combineClassNames(
            "wp-accordion-icon",
            !isOpen && "wp-rotate",
          )}
        >
          <AccordionUpIcon />
        </div>
      </div>
      <div
        className={combineClassNames(
          "wp-accordion-content-wrapper",
          isOpen && "open",
        )}
      >
        <div className="wp-accordion-content">{children}</div>
      </div>
    </div>
  );
};

WPAccordion.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool,
  type: PropTypes.oneOf(["warning", "error"]),
  sideInfo: PropTypes.node,
};

WPAccordion.defaultProps = {
  defaultOpen: false,
  type: undefined,
};

export default WPAccordion;
